import { ObjectUtils } from "~app/common/utils/object-utils";
import { AtgardStatusBase, IAtgardStatus, IAtgardStatusTooltip } from "./atgardheadericons-models";

export class ProduktionsdatumAtgardStatus extends AtgardStatusBase implements IAtgardStatus {
    header = "Produktionsdatum";
    tooltips = [
        {
            header: "Förväntat startdatum:",
            text: this.status.foreslagetProduktionsdatumFrom,
            visible: true
        } as IAtgardStatusTooltip,
{
    header: "Förväntat slutdatum:",
    text: this.status.foreslagetProduktionsdatumTom,
    visible: true
} as IAtgardStatusTooltip
    ];
    icons = [
        {
            visible: true,
            iconclass1: "far fa-calendar",
            incomplete: false,
            warning: false
        }
    ];
    visible(): boolean {
        return ObjectUtils.hasValue(this.status.foreslagetProduktionsdatumFrom) ||
            ObjectUtils.hasValue(this.status.foreslagetProduktionsdatumTom);
    }
}
